export default function (defaultList, list, key) {
  const obj = {}

  for (let i = 0; i < defaultList.length; i++) {
    obj[defaultList[i][key]] = defaultList[i]
  }

  for (let i = 0; i < list.length; i++) {
    if (obj[list[i][key]]) {
      obj[list[i][key]] = {
        ...obj[list[i][key]],
        ...list[i],
      }
    } else {
      obj[list[i][key]] = list[i]
    }
  }

  const arr = Object.keys(obj).map((k) => obj[k])

  return arr
}
